import { useState, useEffect } from "react";
import "./App.css";
var axios = require("axios").default;

//https://rapidapi.com/contextualwebsearch/api/web-search/

function App() {
  // const [storyCount, setStoryCount] = useState();
  const [storyArray, setStoryArray] = useState();

  var options = {
    method: "GET",
    url: "https://contextualwebsearch-websearch-v1.p.rapidapi.com/api/search/TrendingNewsAPI",
    params: {
      pageNumber: "1",
      pageSize: "10",
      withThumbnails: "true",
      location: "us"
    },
    headers: {
      "x-rapidapi-host": "contextualwebsearch-websearch-v1.p.rapidapi.com",
      "x-rapidapi-key": "c1d4bd538dmsh760aacb9e8e1ef3p161128jsn0aa0b306fa8e"
    }
  };

  function callAxios() {
    axios
      .request(options)
      .then(function (response) {
        console.log(response.data.value);
        // let totalCount = response.data.totalCount;
        // setStoryCount(totalCount);
        let values = response.data.value;
        setStoryArray(values);
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  useEffect(() => {
    callAxios();
  }, []);

  return (
    <>
      <h1>Image News</h1>
      <ul>{storyArray}</ul>
    </>
  );
}

export default App;
